<template>
  <a-flex v-if="column.dataIndex === 'actions'" align="center" justify="center">
    <a-button type="text" size="large">
      <template #icon>
        <EditOutlined />
      </template>
    </a-button>

    <a-button type="text" size="large">
      <template #icon>
        <ReloadOutlined />
      </template>
    </a-button>
  </a-flex>

  <span v-else class="default-cell">{{ record[column.dataIndex] }}</span>
</template>

<script setup lang="ts">
import type { MarkingCodesDocumentsTableItem } from "@/stores/product/marking/marking-codes-documents.store";
import { EditOutlined, ReloadOutlined } from "@ant-design/icons-vue";

defineProps<{
  column: {
    dataIndex: keyof MarkingCodesDocumentsTableItem;
    title: string;
  };
  record: MarkingCodesDocumentsTableItem;
}>();
</script>

<style scoped lang="scss">
.default-cell {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ant-btn-icon-only {
  font-size: 20px;
  line-height: 1;
  padding: 0;
}
</style>
